import React from 'react';
import HeadOfAccountsForm from './HeadOfAccountsForm';

const EditHeadOfAccountPage = () => <HeadOfAccountsForm formType="edit" />;

export default EditHeadOfAccountPage;
